import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { useStyles } from "components/Layout/AppDrawer/components/DrawerItem.styles";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import LibraryBooksOutlinedIcon from "@mui/icons-material/LibraryBooksOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import CorporateFareOutlinedIcon from "@mui/icons-material/CorporateFareOutlined";
import { useMatch, useNavigate } from "react-router-dom";
import { CORPORATE_BACKOFFICE_PATHS } from "constants/constants";
import { useTranslation } from "react-i18next";
import { useAllowRCACorporateDashboard } from "hooks/useAllowRCACorporateDashboard";

const RCAAppDrawerItems = () => {
    const paths = {
        dashboard: `/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.RCA.ROOT}`,
        settings: `/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.RCA.ROOT}/${CORPORATE_BACKOFFICE_PATHS.RCA.SETTINGS}`,
        compliance: `/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.RCA.ROOT}/${CORPORATE_BACKOFFICE_PATHS.RCA.COMPLIANCE}`,
        corporate_dashboard: `/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.RCA.ROOT}/${CORPORATE_BACKOFFICE_PATHS.RCA.CORPORATE_DASHBOARD}`,
        issues: `/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.RCA.ROOT}/${CORPORATE_BACKOFFICE_PATHS.RCA.ISSUES.ROOT}`,
        issues_child: `/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.RCA.ROOT}/${CORPORATE_BACKOFFICE_PATHS.RCA.ISSUES.ROOT}/${CORPORATE_BACKOFFICE_PATHS.RCA.ISSUES.VARIABLE}`,
        rca_library: `/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.RCA.ROOT}/${CORPORATE_BACKOFFICE_PATHS.RCA.RCA_LIBRARY.ROOT}`,
        action_plans: `/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.RCA.ROOT}/${CORPORATE_BACKOFFICE_PATHS.RCA.RCA_ACTION_PLANS.ROOT}`,
    };
    const navigate = useNavigate();
    const classes = useStyles();
    const { t } = useTranslation();
    const { isAllowedToUseRCACorporateDashboard } = useAllowRCACorporateDashboard();
    const corporateDashboardMatch = useMatch(paths["corporate_dashboard"]);

    return (
        <>
            {isAllowedToUseRCACorporateDashboard && (
                <ListItemButton
                    className={`${classes.drawerItem} ${corporateDashboardMatch ? classes.drawerItemSelected : ""}`}
                    onClick={() => navigate(paths["corporate_dashboard"])}
                >
                    <ListItemIcon>
                        <CorporateFareOutlinedIcon className={classes.drawerItemIcon} />
                    </ListItemIcon>
                    <ListItemText
                        primary={t("rca.drawer_items.corporate_dashboard")}
                        className={classes.drawerItemText}
                    />
                </ListItemButton>
            )}
            <ListItemButton
                className={`${classes.drawerItem} ${useMatch(paths["dashboard"]) ? classes.drawerItemSelected : ""}`}
                onClick={() => navigate(paths["dashboard"])}
            >
                <ListItemIcon>
                    <DashboardOutlinedIcon className={classes.drawerItemIcon} />
                </ListItemIcon>
                <ListItemText primary={t("rca.drawer_items.my_dashboard")} className={classes.drawerItemText} />
            </ListItemButton>

            <ListItemButton
                className={`${classes.drawerItem} ${useMatch(paths["rca_library"]) ? classes.drawerItemSelected : ""}`}
                onClick={() => navigate(paths["rca_library"])}
            >
                <ListItemIcon>
                    <LibraryBooksOutlinedIcon className={classes.drawerItemIcon} />
                </ListItemIcon>
                <ListItemText primary={t("rca.drawer_items.rca_library")} className={classes.drawerItemText} />
            </ListItemButton>

            <ListItemButton
                className={`${classes.drawerItem} ${useMatch(paths["issues"]) ? classes.drawerItemSelected : ""} ${
                    useMatch(paths["issues_child"]) ? classes.drawerItemSelected : ""
                }`}
                onClick={() => navigate(paths["issues"])}
            >
                <ListItemIcon>
                    <CampaignOutlinedIcon className={classes.drawerItemIcon} />
                </ListItemIcon>
                <ListItemText primary={t("rca.drawer_items.issues")} className={classes.drawerItemText} />
            </ListItemButton>

            <ListItemButton
                className={`${classes.drawerItem} ${useMatch(paths["action_plans"]) ? classes.drawerItemSelected : ""}`}
                onClick={() => navigate(paths["action_plans"])}
            >
                <ListItemIcon>
                    <AssignmentOutlinedIcon className={classes.drawerItemIcon} />
                </ListItemIcon>
                <ListItemText primary={t("rca.drawer_items.action_plans")} className={classes.drawerItemText} />
            </ListItemButton>

            <ListItemButton
                className={`${classes.drawerItem} ${useMatch(paths["settings"]) ? classes.drawerItemSelected : ""}`}
                onClick={() => navigate(paths["settings"])}
            >
                <ListItemIcon>
                    <SettingsOutlinedIcon className={classes.drawerItemIcon} />
                </ListItemIcon>
                <ListItemText primary={t("rca.drawer_items.rca_settings")} className={classes.drawerItemText} />
            </ListItemButton>

            <ListItemButton
                className={`${classes.drawerItem} ${useMatch(paths["compliance"]) ? classes.drawerItemSelected : ""}`}
                onClick={() => navigate(paths["compliance"])}
            >
                <ListItemIcon>
                    <AnalyticsOutlinedIcon className={classes.drawerItemIcon} />
                </ListItemIcon>
                <ListItemText primary={t("rca.drawer_items.rca_ap_compliance")} className={classes.drawerItemText} />
            </ListItemButton>
        </>
    );
};

export default RCAAppDrawerItems;
